<template>
    <li role="menuitem">
        <slot :active="active"></slot>
    </li>
</template>

<script>
export default {
  name: 'i-menu-item',
  inject: ['$dropdownContext'],
  props: {
    index: {
      type: Number,
    },
  },
  computed: {
    dropdownContext() {
      return this.$dropdownContext();
    },
    active() {
      return this.dropdownContext.activeIndex === this.index;
    },
  },
};
</script>
